// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"563966dd","453":"42c5ce65","455":"62363a14","977":"9007c366"}[chunkId] + ".chunk.js";
};